// extracted by mini-css-extract-plugin
module.exports = {"Kairon":"Kairon_Kairon__ynZIN","KaironText":"Kairon_KaironText__3gL81"};